import React, { FC } from 'react'
import PdImage from '@components/pd-image/pd-image'
import { useRouter } from 'next/router'
import { useTranslations } from 'next-intl'
import { EventReportManager } from '@/event-report/event-report-manager'

type Section15Type = {
  theme?: string
  title: string
  imgUrl: string
  paramsList: Array<{
    label: string
    value: Array<string>
  }>
  btntext: string
  robot: string
}

const Section15: FC<Section15Type> = ({ theme, title, imgUrl = '', paramsList = [], btntext, robot }) => {
  const t = useTranslations()
  const router = useRouter()
  function fireContactEvent() {
    const event = { action: '', data: { event: 'initiate_lead' } }
    EventReportManager.getInstance().fireEventImmediately(event, true)
    router.push({ pathname: '/contact-us', query: robot ? { robot } : {} })
  }
  return (
    <div className={['w-full flex flex-col items-center', `pd-theme-${theme}`, 'bg-anti-blk'].join(' ')}>
      <div className={['flex flex-col w-full px-6 py-15', 'laptop:w-300 laptop:py-30 laptop:p-0'].join(' ')}>
        <div className={['w-full flex flex-col laptop:flex-row'].join(' ')}>
          <div
            className={[
              'text-center w-full h-327px mb-8',
              'laptop:w-370px laptop:m-0 laptop:h-[25vw] laptop:mt-6',
            ].join(' ')}
          >
            <PdImage src={imgUrl} enableMask={false} object="contain" width={'100%'} height={'100%'} />
          </div>
          <div className={['laptop:flex-1 laptop:-mt-11', ' -mt-3'].join(' ')}>
            {title && (
              <h2
                className={[
                  'text-fc-primary',
                  'border-b border-[#D4D8E0] font-semibold',
                  'laptop:text-40 laptop:pb-6',
                  'text-24 pb-3',
                ].join(' ')}
              >
                {title}
              </h2>
            )}
            <div className={['laptop:justify-between laptop:flex-row laptop:flex-wrap', 'flex flex-col'].join(' ')}>
              {paramsList.map((item, index) => (
                <div
                  key={index}
                  className={[
                    'mt-3',
                    theme === 'dark' ? 'border-white/50' : 'border-white/50',
                    'laptop:w-90 laptop:flex laptop:flex-col laptop:mt-11 laptop:border-none',
                  ].join(' ')}
                >
                  <p className={['m-0 text-14', 'laptop:text-base', 'text-fc-secondary'].join(' ')}>{item.label}</p>
                  <div className={['flex flex-col mt-7px mb-10px', 'laptop:mt-3 laptop:mb-0'].join(' ')}>
                    {item.value.map((e, i) => (
                      <span
                        key={i}
                        className={['text-12', 'laptop:text-base laptop:font-medium', 'text-fc-primary'].join(' ')}
                      >
                        {e}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
              <div className={['laptop:mt-20 laptop:w-full', 'mt-15'].join(' ')}>
                <span
                  onClick={fireContactEvent}
                  className={[
                    'text-white',
                    'bg-pdblue text-center inline-block w-full py-4 rounded-lg text-18 cursor-pointer',
                    'laptop:inline-black laptop:rounded laptop:py-2 laptop:px-6 laptop:text-16 laptop:w-326px',
                  ].join(' ')}
                >
                  {btntext}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Section15
